import { render, staticRenderFns } from "./CCNpcFeatureCard.vue?vue&type=template&id=b83567ce&"
import script from "./CCNpcFeatureCard.vue?vue&type=script&lang=js&"
export * from "./CCNpcFeatureCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports